import { Checkbox } from "@mui/material";
import { memo } from "react";
import { Dropdown } from "semantic-ui-react";

const displayStringFromFHIRBoolean = (boolean) => {
  if (boolean === true) {
      return "True";
  } else if (boolean === false) {
      return "False";
  } else if (boolean === undefined || boolean === null || boolean === "") {
      return ""
  } else if (typeof (boolean) === "string" && boolean.toLowerCase() === "true") {
      return "True [ERROR: Boolean data in string datatype.]";
  } else if (typeof (boolean) === "string" && boolean.toLowerCase() === "false") {
      return "False [ERROR: Boolean data in string datatype.]";
  } else {
      return "[ERROR: Boolean data not interpretable.]";
  }
}

const BooleanEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState, storeFalse }) => {
    if (storeFalse) {
      const allowedValues = ['True', 'False'];
      let startingValueText;
      if (startingValue === true) {
        startingValueText = "true"
      }
      if (startingValue === false && startingValue !== undefined && startingValue !== null && startingValue !== "") {
        startingValueText = "false"
      }
      return <div>
        <b>{fieldLabel}: </b>
        <Dropdown
          name={elementName}
          placeholder={fieldLabel}
          closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
          style={{ minWidth: "25%", width: "25%" }}
          options={allowedValues.map((code, codeIndex) => { return { "key": codeIndex, "value": code.toLowerCase(), "text": code } })}
          value={startingValueText ?? ""}
          onChange={(e, data) => {
            let booleanValue = "";
            if (data.value === "true") {
              booleanValue = true;
            }
            if (data.value === "false") {
              booleanValue = false;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: booleanValue }; });
          }}
        />
      </div>
    }
    return <span><b>{fieldLabel}: </b>
      <Checkbox checked={startingValue === true || startingValue === "true"}
        onChange={(e) => {
          setResourceState(prevState => { return { ...prevState, [elementName]: e.target.checked }; });
        }}
        color="primary"
        style={{ paddingLeft: "4px", paddingRight: "4px" }}
      /></span>
  });

export default BooleanEntry;
export { displayStringFromFHIRBoolean };